import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/users/User';
import { Salary } from '../../../models/salaries/salary';
import { ActivatedRoute, Router } from '@angular/router';
import { SalaryService } from '../../../services/salary.service';
import { AlertService } from '../../../services/alert.service';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { DateHelper } from '../../../helpers/DateHelper';
import { DailyTripService } from '../../../services/daily-trip.service';
import { PageOption } from '../../../models/common/pageOption';
import { DailyTripHistoryFilter } from '../../../models/trips/dailyTripHistoryFilter';
import { DailyTripHistory } from '../../../models/trips/dailyTripHistory';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ParameterService } from '../../../services/parameter.service';
import { DriverTripHistoryColumns } from '../../../contants/columns/columns.profile.driver.trip.history';
import { HelperTripHistoryColumns } from '../../../contants/columns/columns.profile.helper.trip.history';
import { BookKeeperTripHistoryColumns } from '../../../contants/columns/columns.profile.bookKeeper.trip.history';
import { Helper } from '../../../helpers/Helper';
import { DatePeriod } from '../../../models/dates/datePeriod';
import { PARAMS } from '../../../contants/PARAMS';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

	user: User;
	salary: Salary;
	dailyTripHistory: DailyTripHistory[] = [];
	dailyTripHistoryColumns: TableColumn[] = [];
	dailyTripHistoryViewUrl: string = APP_ROUTES.dailyTripForm.replace('/:id', '');

	dateFrom: string = null;
	dateTo: string = null;

	showDailyTripHistory: boolean = true;
	constructor(
		private _userService: UserService,
		private _activatedRoute: ActivatedRoute,
		private _alertService: AlertService,
		private _router: Router,
		private _dailyTripService: DailyTripService,
		private _parameterService: ParameterService
	) { }

	ngOnInit() {
		let id = this._activatedRoute.snapshot.params['id'];
		this.user = new User();
		this.user.id = id == undefined ? 0 : id;
		
		this.salary = new Salary();
		this.salary.amount = 0;
		this.salary.id = 0;

		if (id == 0) {
			this._userService.getCurrentUser().subscribe(
				result => {
					if(result != undefined){
						this.loadData(result);
					}
					else{
						this._alertService.showError('A problem occured while getting user data');
					}
				}
			)
		}
		else {
			this._userService.getUser(id).subscribe(
				user => {
					if (user != undefined) {
						this.loadData(user);
					}
					else{
						this._alertService.showError('A problem occured while getting user data');
					}
				}
			);
		}
	}

	loadData(source: User) {
		this.user = source;
		
		let dates = DateHelper.getWeeklyPeriod(new Date());
		this.dateFrom = dates.from;
		this.dateTo = dates.to;

		//get salary information
		if(this.user.salaryType === 'MONTHLY'){
			this._userService.getMonthlyUserSalary(this.user.id).subscribe(
				result => {
					if(result != null){
						result.effectiveDate = new Date(result.effectiveDate);
						this.salary = result;
					}
					else{
						this._alertService.showError("A problem occured while retrieving salary data.")
					}
				}
			);
		}

		this.loadDailyTripHistoryColumns();
		this.loadDailyTripHistory();
	}

	loadDailyTripHistoryColumns() {
		let columnParam = '';
		if(this.user.employeeRole === 'DRIVER'){
			columnParam = PARAMS.DRIVER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS;
			this.dailyTripHistoryColumns = DriverTripHistoryColumns;
		}
		else if(this.user.employeeRole === 'HELPER'){
			columnParam = PARAMS.HELPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS;
			this.dailyTripHistoryColumns = HelperTripHistoryColumns;
		}
		else if(this.user.employeeRole === 'BOOK_KEEPER'){
			columnParam = PARAMS.BOOKKEEPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS;
			this.dailyTripHistoryColumns = BookKeeperTripHistoryColumns;
		}
		else if(Helper.isManager()){
			this.showDailyTripHistory = false;
		}

		if(!this.showDailyTripHistory){
			return;
		}

		this._parameterService.getCachedParameterObject<TableColumn[]>(columnParam, 3600).subscribe(
			result => {
				if (result.length != undefined) {
					if(result.length > 0){
						this.dailyTripHistoryColumns = result;
					}
				}
				else {
					console.log('Invalid response from server, will use default column settings instead.')
				}
			}
		);
	}

	loadDailyTripHistory(){
		if(!this.showDailyTripHistory){
			return;
		}

		let options = new PageOption<DailyTripHistoryFilter>();
		options.pageSize = 50;
		options.searchFilter = new DailyTripHistoryFilter();

		options.searchFilter.tripDateFrom = this.dateFrom;
		options.searchFilter.tripDateTo = this.dateTo;

		this._dailyTripService.getDailyTripHistoryList(options).subscribe(
			result => {
				if(result != undefined){
					this.dailyTripHistory = result.data;
				}
			}
		);
	}

	goToChangePassword(){
		this._router.navigate([APP_ROUTES.changePassword]);
	}

	goToEdit() {
		this._router.navigate([APP_ROUTES.userForm.replace('/:id', ''), this.user.id])
	}

	onWeekSelectChange(datePeriod: string){
		let dates = datePeriod.split('|');
		this.dateFrom = dates[0];
		this.dateTo = dates[1];

		this.loadDailyTripHistory();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/users/profile/profile.component.ts